import { createGlobalStyle, css } from "styled-components";
import { appNeutralPalette } from "../../theme/v6/palette";

const GlobalStyle = createGlobalStyle`
 ${css`
   /* Для native и virtual скроллбаров Select нет component token AntD. */
   .ant6-select-dropdown-list {
     --rc-virtual-list-scrollbar-bg: ${appNeutralPalette[3]};
     scrollbar-color: ${appNeutralPalette[3]} ${appNeutralPalette[0]};
   }

   html[data-theme="dark"] .ant6-select-dropdown-list {
     --rc-virtual-list-scrollbar-bg: ${appNeutralPalette[5]};
     scrollbar-color: ${appNeutralPalette[5]} ${appNeutralPalette[7]};
   }

   .ant6-select-dropdown-list-holder {
     scrollbar-width: thin;
   }

   .ant6-tag.ant6-tag-solid:not(.ant6-tag-disabled) > .ant6-tag-close-icon {
     color: inherit;
     opacity: 0.7;
     transition: opacity ${(props) => props.theme.antd6.motionDurationMid};

     &:hover,
     &:focus-visible {
       color: inherit;
       opacity: 1;
     }
   }

   .highlight-flash {
     animation: card-flash 1.25s ease-out;
   }

   .highlight-flash-error {
     animation: card-flash-error 1.25s ease-out;
   }

   @keyframes card-flash {
     0% {
       box-shadow: none;
     }
     50% {
       box-shadow: 0 0 10px ${(props) => props.theme.antd6.colorPrimary};
     }
     100% {
       box-shadow: none;
     }
   }

   @keyframes card-flash-error {
     0% {
       box-shadow: none;
     }
     50% {
       box-shadow: 0 0 10px ${(props) => props.theme.antd6.colorError};
     }
     100% {
       box-shadow: none;
     }
   }
 `}
`;

export default GlobalStyle;
